import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ChevronDown from '@pedidosya/web-fenix/icons/ChevronDown';
import ChevronRight from '@pedidosya/web-fenix/icons/ChevronRight';
import { onKeyUpFunction, onKeyDownFunction } from '@utils/a11y';

const Container = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  width: fit-content;
  margin-right: 12px;
`;

const Text = styled.div`
  ${({ theme }) => theme.fontFamily.mainFont.mediumExtraBold};
  color: ${({ theme }) => theme.colors.deep_purple};
  margin: 4px;
`;

function Title({ text, onClick, showExpandedIcon, ariaControls }) {
  return (
    <Container
      onClick={onClick}
      onKeyUp={e => onKeyUpFunction(e, () => onClick({ e }))}
      onKeyDown={e => onKeyDownFunction(e, () => onClick({ e }))}
      tabIndex={0}
      role="button"
      aria-expanded={showExpandedIcon}
      aria-controls={ariaControls}
    >
      <Text>{text}</Text>
      {showExpandedIcon ? (
        <ChevronDown color="default" size="small" />
      ) : (
        <ChevronRight color="default" size="small" />
      )}
    </Container>
  );
}

Title.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  showExpandedIcon: PropTypes.bool.isRequired,
  ariaControls: PropTypes.string,
};

export default Title;
